export function getCategoryColor(category) {
  const colors = {
    Landmark: "#8B5CF6", // Purple
    Museum: "#3B82F6",   // Blue
    Social: "#F97316",   // Orange
    Park: "#22C55E",     // Green
    Cafe: "#EF4444"      // Red
  };
  return colors[category] || "#6B7280"; // Default to gray-500
}